import React, {useState} from 'react'
import ReactCountryFlag from 'react-country-flag'
import {FaClock} from 'react-icons/fa'
import DataCard from './DataCard'
import DataChart from './DataChart'

const initialState = {
  NewConfirmed: 0,
  TotalConfirmed: 0,
  NewDeaths: 0,
  TotalDeaths: 0,
  NewRecovered: 0,
  TotalRecovered: 0,
  CountryCode: 'AF',
}
function LocalData({MyLocalData, LoadingState}) {
  // const [countries, setCountries] = useState({});
  const [selectedCountry, setSelectedCountry] = useState('Afghanistan')
  const [selectedCountryIndex, setSelectedCountryIndex] = useState(0)
  const handleChange = (e) => {
    setSelectedCountry(e.target.value)
    setSelectedCountryIndex(e.target.selectedIndex)
  }

  const getCountries = () => {
    const countries = MyLocalData.map((item, index) => {
      return {
        key: index,
        value: item.Country,
        flag: item.CountryCode,
        text: item.Country,
      }
    })
    return countries
  }

  const {
    NewConfirmed,
    TotalConfirmed,
    NewDeaths,
    TotalDeaths,
    NewRecovered,
    TotalRecovered,
    CountryCode,
  } = !LoadingState ? MyLocalData[selectedCountryIndex] : initialState
  const Active = TotalConfirmed - TotalRecovered - TotalDeaths
  !LoadingState && console.log(getCountries())
  return (
    <div className="global-box d-flex flex-column align-items-center mt-5">
      <div className="global-title d-flex">
        <label>Please select a country</label>
      </div>
      <ReactCountryFlag
        countryCode={CountryCode}
        svg
        style={{fontSize: '3em', lineHeight: '3em'}}
        title={selectedCountry}
      />
      <select value={selectedCountry} onChange={handleChange}>
        {!LoadingState &&
          MyLocalData.map((item, i) => {
            return (
              <option key={i} value={item.Country}>
                {item.Country}
              </option>
            )
          })}
      </select>

      <div className="container-fluid d-flex flex-md-fill flex-column flex-md-row justify-content-around align-items-center align-items-md-start align-items-lg-start">
        <DataCard
          ID={1}
          IsLoading={LoadingState}
          Title="Confirmed"
          Data={[NewConfirmed, TotalConfirmed]}
          color="rgb(255,0,0)"
        />
        <DataCard
          ID={2}
          IsLoading={LoadingState}
          Title="Active"
          Data={[0, Active]}
          color="rgba(74, 127, 180, 0.7)"
        />
        <DataCard
          ID={3}
          IsLoading={LoadingState}
          Title="Recovered"
          Data={[NewRecovered, TotalRecovered]}
          color="rgb(0,255,0)"
        />
        <DataCard
          ID={4}
          IsLoading={LoadingState}
          Title="Deaths"
          Data={[NewDeaths, TotalDeaths]}
          color="rgb(255,255,255,0.5)"
        />
      </div>
      <div className="data-chart">
        {!LoadingState && <DataChart Country={selectedCountry} />}
      </div>
      {!LoadingState && (
        <div className="text-light">
          <FaClock className="mb-1" size="1.2rem" />
          Last Update:{' '}
          {new Date(MyLocalData[selectedCountryIndex].Date).toLocaleString()}
        </div>
      )}
    </div>
  )
}

export default LocalData
